import React from 'react';
import InfoTooltip from './InfoTooltip';
import { ORANGE_BOOK_PREFACE_URL } from '../utils/teCodeLabels';

export interface TeCodeHeaderTooltipProps {
  /** Forwarded to InfoTooltip — override for a call site nested above InfoTooltip's own default (e.g. LinkToSourceModal's 10002 content layer — see ExternalLinkSuggestionsPane.tsx's own 10003 override). */
  zIndex?: number;
}

/**
 * Field-level tooltip for the "TE Code" label (issue #805, acceptance
 * criterion 1) — explains what the field means and links back to the
 * source. Reuses `InfoTooltip` (already keyboard-accessible and stacks
 * above modal overlays) rather than a bespoke tooltip trigger.
 */
const TeCodeHeaderTooltip: React.FC<TeCodeHeaderTooltipProps> = ({
  zIndex,
}) => (
  <InfoTooltip
    ariaLabel="About TE Code"
    zIndex={zIndex}
    // This tooltip's content contains the "Orange Book Preface" link --
    // opt into InfoTooltip's adjacent-portal placement so it's reachable
    // by a plain Tab press (see InfoTooltip.tsx's `interactive` prop doc).
    interactive
    text={
      <span>
        TE = Therapeutic Equivalence
        <br />
        Source:{' '}
        <a
          href={ORANGE_BOOK_PREFACE_URL}
          target="_blank"
          rel="noopener"
          style={{ color: 'inherit', textDecoration: 'underline' }}>
          Orange Book Preface
        </a>
      </span>
    }
  />
);

export default TeCodeHeaderTooltip;
